<ng-container *ngIf="data">
  <div class="section-accordion-block border-r10 marb24">
    <div class="section-header d-flex ion-align-items-center marb16">
      <div *ngIf="data.icon" class="section-icon-wrap d-flex ion-align-items-center ion-justify-content-center">
        <img [src]="data.icon" [alt]="data.sectionTitle" class="section-icon" />
      </div>
      <ion-label class="fs-5 font700 title-text-color" [class.marl4]="!!data.icon">{{ data.sectionTitle }}</ion-label>
    </div>

    <ion-accordion-group class="ion-no-padding" [multiple]="false" [value]="groupValue" (ionChange)="onAccordionChange($event)">
      <ion-accordion
        *ngFor="let accordion of data.accordions; let i = index"
        [value]="'accordion-' + i"
        toggleIcon="none"
        class="accordion-card marb12 border-r10"
      >
        <ion-item slot="header" color="none" lines="none" class="accordion-header-item">
          <ion-label class="fs-4 font600 accordian-title-text-color">
            {{ accordion.title }}
          </ion-label>
          <ion-icon name="chevron-down-outline" slot="end" class="ion-accordion-toggle-icon accordion-chevron font22 blue-text-color"></ion-icon>
        </ion-item>
        <div class="accordion-content card-white-background-color grey-border-top ion-padding" slot="content">
          <ng-container *ngIf="accordion.sections?.length">
            <div *ngFor="let section of accordion.sections" class="accordion-subsection marb16">
              <p class="accordion-subsection-title fs-4 font600 accordian-title-text-color marb8">{{ section.title }}</p>
              <ul class="accordion-points-list">
                <ng-container *ngFor="let point of section.points">
                  <li *ngIf="getPointDisplay(point) as disp" [ngSwitch]="disp.type" [class.faq-item]="disp.type === 'qa'" class="marb16">
                    <ng-container *ngSwitchCase="'qa'">
                      <p class="faq-question fs-3 font600 accordian-title-text-color marb4">{{ disp.question }}</p>
                      <p class="faq-answer fs-3 font400 accordian-subtitle-text-color mar0 l-height150">{{ disp.answer }}</p>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <span class="accordion-point fs-3 font500 accordian-subtitle-text-color l-height150">{{ disp.text }}</span>
                    </ng-container>
                  </li>
                </ng-container>
              </ul>
            </div>
          </ng-container>
          <ul *ngIf="!accordion.sections?.length && accordion.points?.length" class="accordion-points-list">
            <li *ngFor="let point of accordion.points" class="accordion-point fs-3 font500 accordian-subtitle-text-color marb10 l-height150">
              {{ point }}
            </li>
          </ul>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </div>
</ng-container>
